@if (pwaService.showGuideModal()) {
  <div class="guide-modal-overlay" (click)="closeOnBackdrop($event)" role="dialog" aria-modal="true">
    <div class="guide-modal-card">
      <div class="guide-modal-header">
        <div class="guide-badge">
          <lucide-icon [img]="Smartphone" size="16"></lucide-icon>
          <span>Instalar no iPhone / iPad</span>
        </div>
        <button type="button" class="btn-modal-close" (click)="close()" aria-label="Fechar">
          <lucide-icon [img]="X" size="20"></lucide-icon>
        </button>
      </div>

      <div class="guide-modal-body">
        <h2 class="guide-title">Como adicionar o Cerimonial à sua Tela de Início</h2>
        <p class="guide-subtitle">Siga os 3 passos simples no navegador Safari:</p>

        <div class="guide-steps">
          <div class="step-item">
            <div class="step-number">1</div>
            <div class="step-content">
              <div class="step-label">
                <span>Toque no botão <strong>Compartilhar</strong></span>
                <div class="icon-chip safari-share">
                  <lucide-icon [img]="Share2" size="18"></lucide-icon>
                </div>
              </div>
              <p class="step-desc">Localizado na barra de navegação inferior (iPhone) ou superior (iPad).</p>
            </div>
          </div>

          <div class="step-item">
            <div class="step-number">2</div>
            <div class="step-content">
              <div class="step-label">
                <span>Role a lista e escolha <strong>Adicionar à Tela de Início</strong></span>
                <div class="icon-chip">
                  <lucide-icon [img]="PlusSquare" size="18"></lucide-icon>
                </div>
              </div>
              <p class="step-desc">O ícone possui um quadrado com sinal de adição (+).</p>
            </div>
          </div>

          <div class="step-item">
            <div class="step-number">3</div>
            <div class="step-content">
              <div class="step-label">
                <span>Toque em <strong>Adicionar</strong></span>
                <div class="icon-chip success">
                  <lucide-icon [img]="CheckCircle2" size="18"></lucide-icon>
                </div>
              </div>
              <p class="step-desc">No canto superior direito da tela de confirmação.</p>
            </div>
          </div>
        </div>
      </div>

      <div class="guide-modal-footer">
        <button type="button" class="btn-confirm-guide" (click)="close()">
          Entendi, vou instalar
        </button>
      </div>
    </div>
  </div>
}
